export default __webpack_public_path__ + "static/media/p5_token.3e7a8c02.png";